// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00f0abb3","239":"c62e1796","453":"3430075b","455":"0bf78af9"}[chunkId] + ".chunk.js";
};